module.exports = __webpack_public_path__ + "static/media/teri_williams.b88cd5e4.png";